import React from 'react'

// Components
import Svg from '../Components/shared/Svg'

const CheckMark = props => (
  <Svg viewBox='0 0 36 36' width={36} height={36} fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.643 10.929l1.928 1.928L15.43 27 7.07 18.643 9 16.714l6.429 6.429 12.214-12.214zM33.429 18C33.429 9.5 26.5 2.571 18 2.571S2.571 9.5 2.571 18 9.5 33.429 18 33.429 33.429 26.5 33.429 18zM36 18c0 9.929-8.071 18-18 18S0 27.929 0 18 8.071 0 18 0s18 8.071 18 18z'
      fill='#3CE967'
    />
  </Svg>
)

export default CheckMark
